import { render, staticRenderFns } from "./TekenaarsHeader.vue?vue&type=template&id=32f6bf90&scoped=true&"
import script from "./TekenaarsHeader.vue?vue&type=script&lang=js&"
export * from "./TekenaarsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TekenaarsHeader.vue?vue&type=style&index=0&id=32f6bf90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6bf90",
  null
  
)

export default component.exports